import { useCallback } from 'react';
import { Platform, Pressable, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import { ArrowRightIcon, Text, colors } from '@pletly/ui';
import { useAppUpdateInfo } from '@pletly/feature-check-updates';

export const NewVersionInfo = () => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();

	const { updateInfo } = useAppUpdateInfo();

	const openUpdateInfo = useCallback(() => {
		navigate('UpdateInfo');
	}, [navigate]);

	if (Platform.OS === 'web' || updateInfo.status !== 'success' || !updateInfo.availableUpdate) {
		return null;
	}

	return (
		<Pressable style={styles.root} onPress={openUpdateInfo}>
			<Text category="c1" appearance="alternative">
				{t('about.new-version')}
			</Text>
			<ArrowRightIcon stroke={colors.white} width={16} />
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		backgroundColor: colors.primary700,
		borderRadius: 8,
		paddingHorizontal: 8,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		marginLeft: 'auto',
	},
});
